import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { Alert, Card, EmptyState, Spinner, StarRating, formatDate } from '../../components/ui';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function NannyProfile() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setData(null);
    api.get(`/api/family/nannies/${id}`).then(setData).catch((err) => setError(err.message));
  }, [id]);

  if (error) return <Alert kind="error">{error}</Alert>;
  if (!data) return <Spinner />;

  const { nanny, reviews, averageRating } = data;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>{nanny.fullName}</h1>
          <p className="muted"><Link to="/family/bookings">{t('nannyProfile.backToBookings')}</Link></p>
        </div>
      </div>

      <Card title={t('nannyProfile.aboutTitle')}>
        <div className="avatar-editor">
          {nanny.avatarUrl ? (
            <img className="avatar-preview" src={`${API_BASE}${nanny.avatarUrl}`} alt="" />
          ) : (
            <span className="avatar-preview avatar-preview-fallback">
              {nanny.fullName.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase()}
            </span>
          )}
          <dl className="detail-grid">
            {nanny.yearsExperience != null && (
              <div><dt>{t('nannyProfile.experience')}</dt><dd>{nanny.yearsExperience}</dd></div>
            )}
            {nanny.ageGroups && <div><dt>{t('nannyProfile.ageGroups')}</dt><dd>{nanny.ageGroups}</dd></div>}
            {nanny.qualifications && (
              <div><dt>{t('nannyProfile.qualifications')}</dt><dd>{nanny.qualifications}</dd></div>
            )}
            <div>
              <dt>{t('nannyProfile.firstAid')}</dt>
              <dd>{nanny.firstAidCertified ? t('nannyProfile.yes') : t('nannyProfile.no')}</dd>
            </div>
          </dl>
        </div>
        {nanny.about && <p className="note-block">{nanny.about}</p>}
      </Card>

      <Card title={t('nannyProfile.reviewsTitle', { count: reviews.length })}>
        {averageRating != null && (
          <div className="review-average">
            <strong>{averageRating}</strong>
            <StarRating value={averageRating} readOnly />
            <span className="muted">{t('nannyProfile.basedOn', { count: reviews.length })}</span>
          </div>
        )}
        {reviews.length ? (
          reviews.map((r) => (
            <article key={r.id} className="review-card">
              <header>
                <strong>{r.reviewerName}</strong>
                <span className="muted small">{formatDate(r.createdAt)}</span>
              </header>
              <StarRating value={r.rating} readOnly />
              {r.comment && <p className="review-comment">{r.comment}</p>}
            </article>
          ))
        ) : (
          <EmptyState title={t('nannyProfile.noReviews')} />
        )}
      </Card>
    </>
  );
}
